import { v4 as uuidV4 } from "uuid";

export default function getColumnsConfig(columns) {
  const skipFields = ["uuid", "sessionUuid"];
  return columns
    .filter((column) => column.display && !skipFields.includes(column.field))
    .map((column) => ({
      id: `${column.field}///${uuidV4()}` || "Dummy field",
      name: column.heading || "Dummy heading",
      grow: column.heading.length,
      wrap: true,
      sortable: true,
      reorder: true,
      omit: column.field === "severityText",
      selector: (row) => row[column.field],
    }));
}
